import React from 'react';
import { Box, Typography } from '@mui/material';
import { stats } from './CompanyOverviewVariables';

const CompanyOverview = () => {
  return (
    <Box sx={{ textAlign: 'center', pb: 0, mx: '1rem', m: { xs: '0', md: '0 100px' } }}>
      {/* Title */}
      <Box maxWidth={{ xs: 343, md: 792 }} mx="auto">
        <Typography
          sx={{
            fontWeight: '700',
            fontSize: { xs: '30px', md: '48px' },
            lineHeight: { xs: '38.4px', md: '65.57px' },
          }}
          gutterBottom
        >
          {stats.companyoverviewtitle}
        </Typography>
        {/* Subtitle */}
        <Typography
          sx={{
            fontWeight: '400',
            fontSize: { xs: '14px', md: '18px' },
            lineHeight: { xs: '22.4px', md: '28.8px' },
            textWrap: 'pretty',
            textAlign: 'center',
          }}
          color="#727272"
          mb={4}
        >
          {stats.companyoverviewsubtitle}
        </Typography>
      </Box>
      {/* When we have more stats we will display them here */}
      {/* Stats Section */}
      {/* <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '1rem',
          py: 3,
          px: 2,
          bgcolor: 'black',
          color: 'white',
          maxWidth: { xs: 343, md: 600 },
          mx: 'auto',
        }}
      > */}
      {/* <Grid
          container
          spacing={{ xs: 3, md: 8 }}
          alignItems="center"
          justifyContent="center"
          flexDirection={{ xs: 'column', sm: 'row' }}
        > */}
      {/* Stat 1 */}
      {/* <Grid item xs={4}>
            <Typography
              sx={{
                fontWeight: '700',
                fontSize: { xs: '24px', md: '34px' },
                lineHeight: '44.2px',
              }}
            >
              {stats.companyoverviewstat1}
            </Typography>
            <Typography
              sx={{ fontSize: { xs: '12px', md: '14px' }, fontWeight: '400', lineHeight: '20.8px' }}
            >
              {stats.companyoverviewstat1Sub}
            </Typography>
          </Grid> */}
      {/* Stat 2 */}
      {/* <Divider
            orientation="vertical"
            flexItem
            sx={{ borderColor: 'rgba(255, 255, 255, 0.24)', display: { xs: 'none', sm: 'block' } }}
          /> */}
      {/* <Divider
            orientation="horizontal"
            flexItem
            sx={{ borderColor: 'rgba(255, 255, 255, 0.24)', display: { xs: 'block', sm: 'none' } }}
          /> */}
      {/* <Grid item xs={4}>
            <Typography
              sx={{
                fontWeight: '700',
                fontSize: { xs: '24px', md: '34px' },
                lineHeight: '44.2px',
              }}
            >
              {stats.companyoverviewstat2}
            </Typography>
            <Typography
              sx={{ fontSize: { xs: '12px', md: '14px' }, fontWeight: '400', lineHeight: '20.8px' }}
            >
              {stats.companyoverviewstat2Sub}
            </Typography>
          </Grid> */}
      {/* <Divider
            orientation="vertical"
            flexItem
            sx={{ borderColor: 'rgba(255, 255, 255, 0.24)', display: { xs: 'none', sm: 'block' } }}
          />
          <Divider
            orientation="horizontal"
            flexItem
            sx={{ borderColor: 'rgba(255, 255, 255, 0.24)', display: { xs: 'block', sm: 'none' } }}
          /> */}

      {/* Stat 3 */}
      {/* <Grid item xs={4}> */}
      {/* <Typography
              sx={{
                fontWeight: '700',
                fontSize: { xs: '24px', md: '34px' },
                lineHeight: '44.2px',
              }}
            >
              {stats.companyoverviewstat3}
            </Typography> */}
      {/* <Typography
              sx={{ fontSize: { xs: '12px', md: '14px' }, fontWeight: '400', lineHeight: '20.8px' }}
            >
              {stats.companyoverviewstat3Sub}
            </Typography> */}
      {/* </Grid> */}
      {/* </Grid> */}
      {/* </Box> */}
    </Box>
  );
};

export default CompanyOverview;
